import { createSlice } from "@reduxjs/toolkit";
import { createApi } from "../../utils/api";
import { getActiveParameterConfigurationsEndpoint } from "../../common/endpoints";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const getActiveParameterConfigurations = createApi(
  getActiveParameterConfigurationsEndpoint,
  "GET"
);

const activeParameterConfigSlice = createSlice({
  name: "activeParameterConfig",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getActiveParameterConfigurations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getActiveParameterConfigurations.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getActiveParameterConfigurations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default activeParameterConfigSlice.reducer;